import styled from 'styled-components';
import { BaseMessage } from './BaseMessage';

export const ErrorMessage = styled(BaseMessage)`
  background: #c74158;
  color: #fff;
`;
